import React from "react";
import { Link } from "react-router-dom";
import "../css/home.css";
import "../css/style.css";

function Home() {
  return (
    <div className="home-container">
      <div className="home-content">
        <div className="profile-image-container">
          <img
            src="/images/image.jpeg"
            alt="Anusha Ravichandran"
            className="profile-image"
          />
        </div>
        <div className="bio-content">
          <h1>Anusha Ravichandran</h1>
          <h2>Security Engineer | MS CS @ UC San Diego</h2>
          <div className="bio-text">
            <p>
              Hello! I'm a passionate Security Engineer with expertise in
              cybersecurity and software development. Currently pursuing my
              Master's in Computer Science at UC San Diego, I specialize in
              automating security use cases and building scalable security
              solutions.
            </p>
          </div>
          <div className="skills-section">
            <span className="skill-tag">Incident Response</span>
            <span className="skill-tag">Detection Engineering</span>
            <span className="skill-tag">Security Automation</span>
            <span className="skill-tag">Coding & Cloud Security</span>
          </div>
          <div className="cta-buttons">
            <a
              href="https://drive.google.com/file/d/1H-FoWOxL9TJemBb3QJ_Y8sDjff77LH7K/preview"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              View Resume
            </a>
            <Link to="/contact" className="btn btn-outline">
              Get in Touch
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
